import _loadCrazyEgg from '@/services/loaderPlugin/crazyegg.loader'
import _loadGtm from '@/services/loaderPlugin/gtm.loader.plugin'
import _loadGA4 from '@/services/loaderPlugin/ga4.loader'
import _loadMixpanel from '@/services/loaderPlugin/mixpanel.loader'
import _cookieScript from '@/services/loaderPlugin/cookie-script.loader'

const loaderPlugin = () => {
  _loadGtm()
  _loadCrazyEgg()
  _loadGA4()
  _loadMixpanel()
  // cookieScript have to run the last
  _cookieScript()
}

export default loaderPlugin
